import * as validate from "./../utils/validate-inputs";
import { positiveNumber } from "./../types/number";

//onEverySeconds - triggers every given amount of seconds
export default function oneverySecond(callback, delay) {
  try {
    delay = positiveNumber(delay);
  } catch (e) {
    throw Error(validate.error.time);
  }

  this.time.events.loop(Phaser.Timer.SECOND * delay, () => callback());
}
